export type SoundRiskTone = "success" | "warning" | "danger" | "neutral";

export const getSoundRiskDisplay = (riskLevelCode: string | null | undefined): { label: string; tone: SoundRiskTone } => {
  const riskLevel = riskLevelCode?.toUpperCase();
  if (riskLevel === "HIGH" || riskLevel === "RISK") return { label: "위험 신호", tone: "danger" };
  if (riskLevel === "ATTENTION") return { label: "주의 신호", tone: "warning" };
  if (riskLevel === "CONTEXT") return { label: "참고 신호", tone: "neutral" };
  if (riskLevel === "NONE") return { label: "일반 신호", tone: "success" };
  return { label: "위험도 미지정", tone: "neutral" };
};

export const getSoundEventStatusLabel = (eventStatusCode: string | null | undefined) => {
  if (eventStatusCode === "SAVED") return "운영 저장";
  if (eventStatusCode === "DIAGNOSTIC") return "진단 저장";
  if (eventStatusCode === "SUPERSEDED") return "대체됨";
  return eventStatusCode ?? "-";
};
